/**
 * Texts for header
 */
export const headerText = {
    cookiesIntroText: 'Utilizamos cookies solo para rastrear las visitas a nuestro sitio web, no almacenamos datos personales.',
    cookiesAccept: 'Aceptar cookies',
    cookiesDeny: 'Rechazar cookies',
    tabFAQs: 'Preguntas frecuentes',
    tabSupport: 'Asistencia',
    tabHistory: 'Historia',
    tabReviews: 'Historias',
    tabTraining: 'Formación',
    tabUserTraining: 'Formación usuarios',
    tabHcpTraining: 'Formación sanitarios',
    tabCamAPSLiberty: 'CamAPS Liberty',
    tabPregnancy: 'Embarazo',
    tabAbout: 'Sobre nosotros',
    tabNews: 'Noticias',
    tabCareers: 'Carreras',
    tabOrders: '',
    tabNotifications: 'Notificaciones',
};
